import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]

  connect() {
    this.rating = parseInt(this.inputTarget.value) || 0
    this.render()
  }

  select(event) {
    this.rating = parseInt(event.currentTarget.dataset.value)
    this.inputTarget.value = this.rating
    this.render()
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  hover(event) {
    const value = parseInt(event.currentTarget.dataset.value)
    this.starTargets.forEach((star, index) => {
      star.classList.toggle("text-yellow-400", index < value)
      star.classList.toggle("text-gray-300", index >= value)
      star.classList.toggle("scale-110", index < value)
    })
  }

  reset() {
    this.render()
  }

  render() {
    this.starTargets.forEach((star, index) => {
      star.classList.toggle("text-yellow-400", index < this.rating)
      star.classList.toggle("text-gray-300", index >= this.rating)
      star.classList.remove("scale-110")
    })
  }
}
